// External Dependencies
import 'jquery';
//import 'bootstrap';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js');

// Import common & others
import common from './common';

// Natywny DOMContentLoaded zamiast $(document).ready().
//
// jQuery odpala callbacki ready sekwencyjnie i bez izolacji — nieprzechwycony
// wyjątek we wcześniejszym callbacku (np. wtyczki wołającej grecaptcha,
// który nie załadował się z zewnątrz) zatrzymuje wszystkie kolejne, w tym
// inicjalizację motywu. Zaobserwowane lokalnie: bez dostępu do google.com
// karta produktu zostawała bez JS.
function boot() {
    try {
        common.init();
    } catch (error) {
        console.error('Theme init error:', error);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
} else {
    boot();
}



// WEBPACK FOOTER //
// ./scripts/main.js